import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { GetTemplateRequestType, GetTemplateResponseType } from '../types';

export const getTemplate = async ({
  pathParams: { templateId },
}: GetTemplateRequestType) => {
  const url = `/api/v2/templates/${templateId}`;

  const { data } = await apiAuthClient.get<GetTemplateResponseType>(url);

  return data.data;
};
